<template>
  <div class="onboard-page">
    <div class="onboard-card">
      <div class="onboard-header">
        <img class="onboard-icon" :src="brandLogo" alt="" />
        <p class="onboard-subtitle">Create beautiful websites with AI</p>
      </div>

      <div class="onboard-actions">
        <router-link to="/create" class="onboard-btn onboard-btn-primary">
          Get Started
        </router-link>

        <router-link to="/sites" class="onboard-btn onboard-btn-ghost">
          View My Sites
        </router-link>
      </div>

      <div class="onboard-footer">
        Powered by AI · Simple · Fast
      </div>
    </div>
  </div>
</template>

<script>
import brandLogo from '../assets/bw-logo-wordmark.svg'

export default {
  name: 'Onboard',
  setup() {
    return { brandLogo }
  }
}
</script>

<style scoped>
.onboard-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  color: var(--text-primary);
  background:
    radial-gradient(circle at 20% 10%, rgba(124,109,250,0.22), transparent 32rem),
    radial-gradient(circle at 80% 80%, rgba(56,189,248,0.12), transparent 28rem),
    var(--surface-base);
}

.onboard-card {
  width: 100%;
  max-width: 420px;
  padding: 36px 28px;
  background: var(--glass-bg);
  border: var(--glass-border-hi);
  border-radius: var(--radius-lg);
  backdrop-filter: var(--glass-blur);
  -webkit-backdrop-filter: var(--glass-blur);
  box-shadow: var(--elev-lg);
}

.onboard-header { text-align: center; margin-bottom: 24px; }

.onboard-icon {
  display: block;
  width: min(260px, 80vw);
  height: auto;
  margin: 0 auto 14px;
  border-radius: 0;
  object-fit: contain;
}

.onboard-title {
  margin: 0;
  font-size: 28px;
  font-weight: 800;
  color: var(--text-primary);
  letter-spacing: -0.03em;
}

.onboard-subtitle {
  margin: 6px 0 0;
  color: var(--text-secondary);
  font-size: 14px;
}

.onboard-actions { display: flex; flex-direction: column; gap: 10px; }

.onboard-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  border-radius: var(--radius-sm);
  font-weight: 600;
  font-size: 14px;
  text-decoration: none;
  transition: all 0.15s;
  border: var(--glass-border);
}
.onboard-btn-primary {
  background: var(--accent);
  border-color: rgba(124,109,250,0.5);
  color: #fff;
  box-shadow: 0 0 18px var(--accent-glow);
}
.onboard-btn-primary:hover {
  background: #6d5ef0;
  box-shadow: 0 0 28px var(--accent-glow);
}
.onboard-btn-ghost {
  background: var(--glass-bg);
  color: var(--text-primary);
}
.onboard-btn-ghost:hover {
  background: var(--glass-bg-hover);
  border: var(--glass-border-hi);
}

.onboard-footer {
  margin-top: 22px;
  text-align: center;
  color: var(--text-muted);
  font-size: 12px;
}
</style>
